import styled from "@emotion/styled";
import { Button } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const FooterProduct: FC = () => {

  const navigate = useNavigate();

  return (
    <ButtonWrapper>
      <Button size="large" type="primary" onClick={() => {
        navigate("/manage-product/create-product");
      }} style={{ width: "100%" }}>
        เพิ่มสินค้าใหม่
      </Button>
    </ButtonWrapper>
  );
};

export default FooterProduct;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
